import { SegmentedControl } from '@/shared/components/ui/SegmentedControl';
import { useI18n } from '@/shared/i18n/useT';
import { THEME_MODES, type ThemeMode } from './applyTheme';
import { useTheme } from './useTheme';

/** Theme selector: light / dark / system. Present in Settings on both brands. */
export function ThemeSwitcher() {
  const { mode, resolved, setMode } = useTheme();
  const { t } = useI18n();

  return (
    <SegmentedControl<ThemeMode>
      legend={t('settings.theme.label')}
      name="theme"
      value={mode}
      onChange={setMode}
      options={THEME_MODES.map((value) =>
        value === 'system'
          ? {
              value,
              label: t('settings.theme.system'),
              hint: t('settings.theme.systemHint', { theme: resolved }),
            }
          : { value, label: t(`settings.theme.${value}`) },
      )}
    />
  );
}
